/*
 *  Copyright (c) Qwoach LLC 2026. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 */

export const TlswAudienceEnum = Object.freeze({
	AUDIENCE_ADULT: "AUDIENCE_ADULT",
	AUDIENCE_CHILD: "AUDIENCE_CHILD",
})

export const TlswAudienceOrder = [
	TlswAudienceEnum.AUDIENCE_ADULT,
	TlswAudienceEnum.AUDIENCE_CHILD,
]
